/* 🤖 this file was generated by svg-to-ts */
export const matIconWest: {
  name: 'west';
  data: string;
} = {
  name: 'west',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m9 19 1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z"/></svg>`
};
